/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type EventPostRequest,
    EventPostRequestFromJSON,
    EventPostRequestToJSON,
} from '../models/EventPostRequest';

export interface PostActionsSdkRequest {
    eventPostRequest: EventPostRequest;
}

export interface PostEventsRequest {
    eventPostRequest: EventPostRequest;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Creates request options for postActionsSdk without sending the request
     */
    async postActionsSdkRequestOpts(requestParameters: PostActionsSdkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eventPostRequest'] == null) {
            throw new runtime.RequiredError(
                'eventPostRequest',
                'Required parameter "eventPostRequest" was null or undefined when calling postActionsSdk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/sdk`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventPostRequestToJSON(requestParameters['eventPostRequest']),
        };
    }

    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */
    async postActionsSdkRaw(requestParameters: PostActionsSdkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postActionsSdkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */
    async postActionsSdk(requestParameters: PostActionsSdkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postActionsSdkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postEvents without sending the request
     * @deprecated
     */
    async postEventsRequestOpts(requestParameters: PostEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eventPostRequest'] == null) {
            throw new runtime.RequiredError(
                'eventPostRequest',
                'Required parameter "eventPostRequest" was null or undefined when calling postEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/events`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventPostRequestToJSON(requestParameters['eventPostRequest']),
        };
    }

    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     * @deprecated
     */
    async postEventsRaw(requestParameters: PostEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     * @deprecated
     */
    async postEvents(requestParameters: PostEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postEventsRaw(requestParameters, initOverrides);
    }

}
